import {WarningBanner} from '@/components/commons/warning-banner/WarningBanner'
import {Button} from '@/components/ui/button/Button'
import {
    Dialog,
    DialogBody,
    DialogDisclosure,
    DialogDismiss,
    DialogFooter,
    DialogHeader,
    DialogHeading,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {LayoutAlt03Icon, SpacingWidth01Icon} from '@/components/ui/icon/Icon'
import {StyledNotAllowedRenewalTrigger} from '@/features/projects/components/not-allowed-renewal-dialog/style'
import {ProjectType} from '@/features/projects/types'
import {TKey, useTranslation} from '@/translations/i18n'
import {useDialogStore} from '@ariakit/react'

export const NotAllowedRenewalDialog = ({projectType}: {projectType: ProjectType}) => {
    const {t} = useTranslation()
    return (
        <DialogProvider>
            <DialogDisclosure
                render={
                    <StyledNotAllowedRenewalTrigger variant="ghost" size="sm">
                        {projectType == 'continuous' ? (
                            <>
                                <LayoutAlt03Icon />
                                {t('projects:renew_project_title')}
                            </>
                        ) : (
                            <>
                                <SpacingWidth01Icon />
                                {t('projects:extends_project')}
                            </>
                        )}
                    </StyledNotAllowedRenewalTrigger>
                }
            />
            <Dialog width="400px">
                <NotAllowedRenewalDialogContent projectType={projectType} />
            </Dialog>
        </DialogProvider>
    )
}

const NotAllowedRenewalDialogContent = ({projectType}: {projectType: ProjectType}) => {
    const {t} = useTranslation()
    const dialogStore = useDialogStore()

    const projectTypeToCopy = {
        cyclic: {
            heading: 'projects:extends_project_title',
            title: 'projects:not_allowed_extends_dialog_title',
            subtitle: 'projects:not_allowed_extends_dialog_subtitle'
        },
        continuous: {
            heading: 'projects:renew_project_title',
            title: 'projects:not_allowed_renewal_dialog_title',
            subtitle: 'projects:not_allowed_renewal_dialog_subtitle'
        }
    } as const satisfies Record<ProjectType, {heading: TKey; title: TKey; subtitle: TKey}>

    const {heading, title, subtitle} = projectTypeToCopy[projectType]

    return (
        <>
            <DialogHeader onClick={() => dialogStore.hide()}>
                <DialogHeading>{t(heading)}</DialogHeading>
            </DialogHeader>
            <DialogBody>
                <WarningBanner title={t(title)} subtitle={t(subtitle)} />
            </DialogBody>
            <DialogFooter>
                <DialogDismiss render={<Button variant="secondary" />}>{t('commons:close')}</DialogDismiss>
            </DialogFooter>
        </>
    )
}
